import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import theme from './theme';
import Hero from './components/Hero';

const APK_URL = `${process.env.PUBLIC_URL}/StockPolice_v2.0.0.apk`;

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="App">
        <Hero apkUrl={APK_URL} />
      </div>
    </ThemeProvider>
  );
}

export default App;
